import { Index } from '../features/practiceMenu/Index';
import { THEMES } from '../constants/Consts';

interface PracticeMenuProps {
  themeType: THEMES;
}

export const PracticeMenu = ({ themeType }: PracticeMenuProps) => {
  return <Index themeType={themeType} />;
};
